<template>
    <div id="main-wrapper">
        <!-- <loading :active.sync="isLoading" :height="70" :width="70" :can-cancel="false" :is-full-page="true"></loading> -->

        <div id="app">
            <component :is="layout">
              <!-- keep-alive does not work well, it introduces glitches with browser location fetching etc -->
              <!--<keep-alive include="Book">-->
                <router-view />
              <!--</keep-alive>-->
            </component>
        </div>
    </div>
</template>

<script>
const default_layout = "default";
import { AuthService } from "./services/auth-service";
import "./components/ImportedComponents";
import CustomLoaderComponent from "./components/CustomLoaderComponent.vue";

export default {
    name: "App",
    components: {
        CustomLoaderComponent
    },
    async created() {

        import(process.env.VUE_APP_THEME_PATH);
        
        this.$bus.$on("showLoader", () => this.showLoader());
        this.$bus.$on("hideLoader", () => this.hideLoader());
        this.$http.interceptors.response.use(
            (response) => {
                if (response.status === 200 || response.status === 201) {
                    return Promise.resolve(response);
                } else {
                    return Promise.reject(response);
                }
            },
            (err) => {
                if (err.response.status === 401 || err.response.status === 403) {
                    AuthService.logout();
                    this.hideLoader();
                    this.$router.push({ name: "Login" });
                }
                return Promise.reject(err.response);
                // return new Promise(function() {
                //     if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                //         this.$store.dispatch("logout");
                //     }
                //     throw err;
                // });
            },
            
        );

        await AuthService.getUserProfile();

        const params = new URLSearchParams(window.location.search);
        let trackingParams = {};
        for (let [key, value] of params) {
          trackingParams[key] = value;
        }

        if (Object.keys(trackingParams).length > 0) {
          localStorage.setItem('utm_params', JSON.stringify(trackingParams));
        }
    },
    data() {
        return {
            isLoading: false,
            loader: null,
        };
    },

    methods: {
        showLoader() {
            //this.isLoading = true;
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
                height: 168,
                width: 168,
            }, {
                default: this.$createElement('custom-loader-component'),
            });
        },
        hideLoader() {
            // this.isLoading = false;
            this.loader.hide();
        },
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + "-layout";
        },
    },
};
</script>

<style>
@import "./design/app-style.css";
@import './assets/css/font-awesome.min.css';
</style>
